'use client';

import React from 'react';
import { Box, Stack } from '@mui/material';
import SplideSlider from '@components/SplideSlider';
import { ArrowLeftIcon, ArrowRightIcon } from '@components/SVGIcon/Icons';
import DynamicTabs from '@components/DynamicTabs';
import CustomImage from '@components/CustomImage';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import cn from './style.module.scss';
export default function WharfDesigned(props: any) {
  const wharfDesignedSliderSettings = {
    type: 'loop',
    pagination: true,
    arrows: true,
    autoplay: true,
    speed: 2000,
    interval: 6000,
  };

  const wharfDesignedSlideElement =
    props?.locale?.section?.ransomDesignedSlider ?? [];

  return (
    <Stack component="section" className={cn.wharfDesignedWrapper}>
      <Box className={cn.wharfDesignedInner}>
        <Box className={cn.wharfDesignedHeader}>
          <Box className={cn.wharfDesignedHeader__heading}>
            <ParallaxText
              variant="h2"
              animationType="zoomIn"
              animationDuration={500}
            >
              {ReactHtmlParser(props.locale.section['ransomDesignedHeading'])}
            </ParallaxText>
          </Box>
          <Box className={cn.wharfDesignedHeader__data}>
            <Box className={cn.wharfDesignedParagraph}>
              <ParallaxText
                variant="p"
                animationType="zoomIn"
                animationDuration={500}
              >
                {ReactHtmlParser(props.locale.section['ransomDesignedContent'])}
              </ParallaxText>
            </Box>
          </Box>
        </Box>
        <Box className={cn.wharfDesignedBlock}>
          <SplideSlider
            showArrows
            showPagination
            responsive={{
              mobile: {
                arrows: true,
                pagination: false,
              },
              tablet: {
                arrows: true,
                pagination: false,
              },
              desktop: {
                arrows: true,
                pagination: true,
              },
            }}
            arrowsClassName={cn.wharfDesignedArrows}
            prevClassName={cn.designedArrowsPrev}
            nextClassName={cn.designedArrowsNext}
            paginationClassName={cn.wharfDesignedPagination}
            dotClassName={cn.designedPaginationDots}
            activeDotClassName={cn.designedPaginationActive}
            options={wharfDesignedSliderSettings}
            prevArrow={<ArrowLeftIcon />}
            nextArrow={<ArrowRightIcon />}
          >
            {wharfDesignedSlideElement.map((slide: any, slideIndex: number) => {
              const tabs = slide.tabs.map((tab: any) => ({
                title: tab.tabButton,
                content: (
                  <Box className={cn.wharfDesignedStory}>
                    <Mobile>
                      <CustomImage
                        src={tab.image.mobileUrl}
                        alt={tab.image.alt}
                        width={768}
                        height={768}
                      />
                    </Mobile>
                    <Desktop>
                      <CustomImage
                        src={tab.image.url}
                        alt={tab.image.alt}
                        width={768}
                        height={768}
                      />
                    </Desktop>
                  </Box>
                ),
              }));
              return (
                <Box key={slideIndex} className={cn.wharfDesignedSlide}>
                  <DynamicTabs
                    tabs={tabs}
                    slideDirection="vertical"
                    className={cn.wharfDesignedWrapper}
                    tabClass={cn.wharfDesignedTabs}
                    listClassName={cn.wharfDesignedList}
                    activeClassName={cn.wharfDesignedActive}
                    contentClass={cn.wharfDesignedContent}
                  />
                </Box>
              );
            })}
          </SplideSlider>
        </Box>
      </Box>
    </Stack>
  );
}
